import {DTNode, DTSocialCreativeNode} from 'common/src/modules/decisionTree/decisionTree.types';
import {ServerNode} from 'common/src/modules/nodes/nodes.types';
import {serializeCreativeNode} from 'common/src/modules/campaigns/utils/serializeConceptCreativeNode';

export function serializeTiktokCreativeNode(node: DTNode, newNode: ServerNode) {
  const creativeNode = node as DTSocialCreativeNode;

  return {
    ...serializeCreativeNode(node, newNode),
    type: creativeNode.type,
    externalAdPrimaryText: creativeNode.externalAdPrimaryText || [],
    externalAdHeadline: creativeNode.externalAdHeadline || [],
    externalAdLongHeadline: creativeNode.externalAdLongHeadline || [],
    externalAdDescription: creativeNode.externalAdDescription || [],
    externalAdCTA: creativeNode.externalAdCTA,
    displayUrl: creativeNode.displayUrl,
    identity: creativeNode.identity,
    trackingPixel: creativeNode.trackingPixel,
    adNameTemplate: creativeNode.adNameTemplate || null,
    mediaNameTemplate: creativeNode.mediaNameTemplate || null,
    ...(creativeNode.adType ? {adType: creativeNode.adType} : {}),
    doubleVerifyTracking: creativeNode.doubleVerifyTracking,
    doubleVerifyMeasure: creativeNode.doubleVerifyMeasure,
    trackingPixels: creativeNode.trackingPixels,
  };
}

